import request from '@/utils/request'

// post
export function postAction(url, parameter) {
  return request({
    url: url,
    method: 'post',
    data: parameter,
  })
}

// put
export function putAction(url, parameter) {
  return request({
    url: url,
    method: 'put',
    data: parameter,
  })
}

// put
export function putParamsAction(url, parameter) {
  return request({
    url: url,
    method: 'put',
    params: parameter,
  })
}

// get
export function getAction(url, parameter) {
  return request({
    url: url,
    method: 'get',
    params: parameter,
  })
}

// get
export function getActionRest(url, parameter) {
  return request({
    url: url + parameter,
    method: 'get',
  })
}

// deleteAction
export function deleteAction(url, parameter) {
  return request({
    url: url,
    method: 'delete',
    params: parameter,
  })
}

// importAction
export function importAction(url, parameter) {
  return request({
    url: url,
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundary0JzNxjmdJlAsNrz4',
    },
  })
}
